var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { msalReady } from "../../auth/msal";
const DEBUG_PREFIX = "[AUTH-REDIRECT]";
export default function AuthRedirect() {
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const [status, setStatus] = useState("Processing login…");
    // Step 1: Wait for msalReady (which handles initialization + redirect processing)
    useEffect(() => {
        let isMounted = true;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                yield msalReady;
            }
            catch (err) {
                console.error(DEBUG_PREFIX, "msalReady FAILED:", err);
                if (isMounted) {
                    setStatus("Authentication error. Redirecting to login…");
                    navigate("/login", { replace: true });
                }
                return;
            }
            if (!instance.getActiveAccount() && instance.getAllAccounts().length === 0) {
                console.warn(DEBUG_PREFIX, "No account after msalReady — redirecting to /login");
                if (isMounted) {
                    setStatus("No account found. Redirecting to login…");
                    navigate("/login", { replace: true });
                }
                return;
            }
            if (isMounted) {
                setStatus("Signed in. Redirecting…");
            }
        }))();
        return () => { isMounted = false; };
    }, [instance]);
    // Step 2: Once accounts are populated in React state, navigate to the target
    useEffect(() => {
        if (accounts.length > 0 && inProgress === "none") {
            const target = sessionStorage.getItem("postLoginRedirect") || "/project";
            navigate(target, { replace: true });
        }
    }, [accounts, inProgress, navigate]);
    return (React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", minHeight: "200px" } },
        React.createElement("span", null, status)));
}
